
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register/[[...productParam]]",
      function () {
        return require("private-next-pages/register/[[...productParam]]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/register/[[...productParam]]"])
      });
    }
  